import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=1997fef0&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"
import style0 from "./AboutView.vue?vue&type=style&index=0&id=1997fef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1997fef0",
  null
  
)

export default component.exports